module.exports = __webpack_public_path__ + "static/media/clear.47cb13ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/online-assets/sprites/clear.png
// module id = 2752
// module chunks = 0